// extracted by mini-css-extract-plugin
export var field = "field-module--field--5PuRs";
export var zzz = "field-module--zzz--2oo_J";
export var label = "field-module--label--32BUt";
export var item = "field-module--item--5wcYt";
export var items = "field-module--items--QCTBT";
export var labelAbove = "field-module--labelAbove--1Aslw";
export var labelInline = "field-module--labelInline--1Wz23";
export var labelItems = "field-module--labelItems--3d72d";
export var summary = "field-module--summary--Zir5x";